import React from "react";
import style from "./TopSection.module.css";
import Card from "./TopBlogCard/TopBlogCard";
import NewsLetter from "./NewsLetter/NewsLetter";
function TopSection() {
  return (
    <div className={style.wrapper}>
      <Card />
      <NewsLetter
        display="displayCol"
        imgSrc="https://invozone.com/wp-content/uploads/2020/04/Newsletter.png"
      />
    </div>
  );
}

export default TopSection;
